import { ContentEntity } from '@/types/schema';

const DUMMY_IMAGE = 'https://leverageedu.com/blog/wp-content/uploads/2019/08/Course-after-MBA.png';

export const getContentImage = (content: ContentEntity) => {
  return {
    image: DUMMY_IMAGE,
  };
};
